export default "__VITE_ASSET__BxYZwgaj__"